import { css as e, styled as r } from "styled-components";
import { SmallHeavy as t } from "../../../../styles/typography/index.js";
import { Colors as o } from "../../../../styles/colors/index.js";
import { Theme as n } from "../../../../styles/themes/index.js";
const i = e`
  ${t}

  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 2px 8px 2px 4px;
  border-radius: 4px;
  text-transform: uppercase;

  i {
    margin-right: 4px;
  }
`, s = r.div`
  ${i}

  color: rgb(${o.White});
  background-color: rgb(${n.colors.Brand});

  i {
    font-size: 16px;
  }
`, c = r.div`
  ${i}
  color: rgb(${o.Graphite});
  background-color: rgb(${o.Yellow});
  i {
    font-size: 16px;
  }
`;
export {
  s as TipBadgeContainer,
  c as TopBadgeContainer
};
